import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {Button, Dialog, DialogActions, DialogTitle, withStyles} from "@material-ui/core";
import MuiDialogContent from "@material-ui/core/DialogContent/DialogContent";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseIcon from '@material-ui/icons/Close';
import {deleteFaq, deleteFaqClearState, getFaqList} from "../../../../../../redux/actions/Web/Faq/faqActions";
import {isDefined} from "../../../../../../utils";
import faqStyles from "./faqStyles";

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DeleteFaq = ({faq, question, propertyWebId}) => {
    const {t} = useTranslation();
    const classes = faqStyles();
    const dispatch = useDispatch();

    const deleteData = useSelector(state => state.faqReducers?.deleteFaq);
    const deleteFetching = useSelector(state => state.faqReducers?.deleteFaqFetching);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (isDefined(deleteData?.status) && deleteData.status === 200 && open) {
            setOpen(false);
            dispatch(deleteFaqClearState());
            dispatch(getFaqList({property_web_id: propertyWebId}));
        }
    }, [deleteData, open, dispatch, propertyWebId]);

    const handleDelete = () => {
        dispatch(deleteFaq({
            property_web_id: propertyWebId,
            faq_group_id: faq?.faq_group_id,
        }));
    };

    return (
        <>
            <Tooltip title={t('btn-delete')} placement="top">
                <IconButton className={classes.iconBtn} onClick={() => setOpen(true)}>
                    <i className="fas fa-trash-alt"/>
                </IconButton>
            </Tooltip>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="faq-delete-dialog-title"
                aria-describedby="faq-delete-dialog-description"
                PaperProps={{style: {borderRadius: 14, maxWidth: 460}}}
            >
                <DialogTitle className="red-bottom-border" id="faq-delete-dialog-title">
                    {t('enw-web_alert-title')}
                    <IconButton aria-label="close" className='closeIcon' onClick={() => setOpen(false)}>
                        <CloseIcon className="close-button"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography
                        id="faq-delete-dialog-description"
                        style={{fontSize: 14, color: '#4a5568', lineHeight: 1.6}}
                    >
                        {t('enw-web-faq-delete_desc', 'Bu soru tüm dilleriyle birlikte silinecek ve web sitenizden kaldırılacak.')}
                    </Typography>

                    {isDefined(question) &&
                        <Box
                            style={{
                                marginTop: 14,
                                padding: '12px 14px',
                                borderRadius: 10,
                                background: '#fafbfc',
                                border: '1px solid #eef1f6',
                                fontSize: 14,
                                fontWeight: 600,
                                color: '#2d3748',
                            }}
                        >
                            <i className="fas fa-question-circle" style={{color: '#d71f26', marginRight: 8}}/>
                            {question}
                        </Box>
                    }

                    <DialogActions className='pb-0' style={{marginTop: 20}}>
                        <Button onClick={() => setOpen(false)} autoFocus className="room-rate-modal-save bg-dark-grey">
                            {t('enw-input-checkbox-no')}
                        </Button>
                        <Button
                            onClick={deleteFetching ? undefined : handleDelete}
                            className="room-rate-modal-save bg-red"
                            style={{cursor: deleteFetching ? 'wait' : 'pointer'}}
                        >
                            {deleteFetching &&
                                <CircularProgress className={classes.spinner} size={16} thickness={5} style={{color: '#fff', marginRight: 8}}/>
                            }
                            {t('enw-input-checkbox-yes')}
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default DeleteFaq;
